'use client';

import { LoginForm } from './LoginForm';

export function LoginPage() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-gradient-to-br from-primary to-primary-dark px-4">
      <div className="w-full max-w-md">
        {/* Logo/Header */}
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-white shadow-lg">
            {/* Logo placeholder - replace with actual logo */}
            <svg
              className="h-12 w-12 text-primary"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
              />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-white">Danh bạ doanh nghiệp</h1>
          <p className="mt-2 text-sm text-white/80">Đăng nhập để tiếp tục</p>
        </div>

        {/* Login Form Card */}
        <div className="rounded-3xl bg-white p-8 shadow-2xl">
          <h2 className="mb-6 text-center text-xl font-semibold text-slate-900">Đăng nhập</h2>
          <LoginForm />
        </div>

        {/* Footer */}
        <div className="mt-6 text-center text-sm text-white/70">
          <p>&copy; {new Date().getFullYear()} - Hệ thống Danh bạ nội bộ</p>
        </div>
      </div>
    </div>
  );
}
